import { useTheme } from '@mui/material'
import { LoadingSpinnerProps } from './types'
import { ButtonLoadingSpinner, ButtonLoadingSpinnerProps } from './variants/ButtonLoadingSpinner'
import { NavigationLoadingSpinner } from './variants/NavigationLoadingSpinner'

export function LoadingSpinner(props: LoadingSpinnerProps & Partial<ButtonLoadingSpinnerProps>) {
  const theme = useTheme()
  switch (props.type) {
    case 'button':
      return <ButtonLoadingSpinner {...props} />
    case 'auth':
      return <NavigationLoadingSpinner {...props} />
    case 'navigation':
      return (
        <NavigationLoadingSpinner
          spinnerColor={theme.palette.common.doss.gray[7]}
          {...props}
          spinnerSize={14}
          thickness={6}
        />
      )
    case 'table-cell':
      return (
        <NavigationLoadingSpinner
          fullHeight
          fullWidth
          spinnerColor={theme.palette.common.doss.gray[8]}
          {...props}
        />
      )
    case 'search':
      return (
        <NavigationLoadingSpinner
          fullHeight
          fullWidth
          spinnerColor={theme.palette.common.doss.gray[10]}
          spinnerSize={14}
          {...props}
        />
      )
  }
}
